var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-3 py-3 text-center"},[_c('div',{staticClass:"h5"},[_vm._t("header")],2),_c('div',[_vm._t("main")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }